
export { GenIcon } from "/vercel/path0/node_modules/react-icons/lib/iconBase.mjs"